import { warnInDev } from "./warnInDev.js";
const MINIMUM_ROWS = 2;
const MAXIMUM_ROWS = 8;
function normalizeRows(minRows, maxRows) {
  let normalizedMinRows = minRows || MINIMUM_ROWS;
  let normalizedMaxRows = maxRows || MAXIMUM_ROWS;
  if (normalizedMinRows > normalizedMaxRows) {
    warnInDev(`Textarea "minRows" (${normalizedMinRows}) is bigger than "maxRows" (${normalizedMaxRows}).`);
    normalizedMinRows = normalizedMaxRows;
  }
  if (normalizedMinRows < MINIMUM_ROWS) {
    warnInDev(`Textarea "minRows" (${minRows}) can't be smaller than 2.`);
    normalizedMinRows = MINIMUM_ROWS;
  }
  if (normalizedMaxRows > MAXIMUM_ROWS) {
    warnInDev(`Textarea "maxRows" (${maxRows}) can't be bigger than 8.`);
    normalizedMaxRows = MAXIMUM_ROWS;
  }
  return [normalizedMinRows, normalizedMaxRows];
}
export {
  MAXIMUM_ROWS,
  MINIMUM_ROWS,
  normalizeRows
};
//# sourceMappingURL=normalizeRows.js.map
